import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';
import cn from 'classnames';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import CSSModules from 'react-css-modules';

import Icon from '../../Icon';
import Avatar from '../../Avatar';
import Card from '../../Card';
import TextMessageForm from '../TextMessageForm';
import { ACTIONS } from '../../../constants/strings';
import { COLORS } from '../../../constants/styles';
import { ALLOW_SOCIAL_CHAT_CREATION } from '../../../constants/chat';

import styles from './styles.styl';

const sendMessageIconStyle = { fill: COLORS.fontPrimary };

const CollapsedSendMessageItem = ({
  profile,
  withLine,
  onSubmit,
  intl: { formatMessage },
}) => {
  const userName = get(profile, 'username');
  const displayableName = get(profile, 'displayableName', userName);
  const avatar = get(profile, 'avatar.thumbMin');
  const role = get(profile, 'role');
  const formattedRole = role
    ? formatMessage({ id: `circles.roles.${role}` })
    : '';

  const [showTextField, toggleTextField] = useState(false);

  return (
    <div styleName={cn('root', { 'root--bottomLine': withLine })}>
      <div styleName="heading">
        <If condition={profile}>
          <Card
            text={{
              primary: displayableName,
              complementary: formattedRole,
            }}
            additionalContent={{
              left: (
                <Avatar children={displayableName} size={36} src={avatar} />
              ),
            }}
          />
        </If>
        <If condition={ALLOW_SOCIAL_CHAT_CREATION}>
          <div
            styleName="sendMessage"
            onClick={() => toggleTextField(!showTextField)}
          >
            <Icon name="comment" style={sendMessageIconStyle} />
            <span styleName="sendMessage__text">
              {formatMessage(ACTIONS.chat.sendMessage)}
            </span>
          </div>
        </If>
      </div>
      <If condition={showTextField}>
        <TextMessageForm
          onSendMessage={onSubmit}
          formatMessage={formatMessage}
          onClose={() => toggleTextField(false)}
        />
      </If>
    </div>
  );
};

CollapsedSendMessageItem.propTypes = {
  withLine: PropTypes.bool,
  profile: PropTypes.object,
  onSubmit: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

CollapsedSendMessageItem.defaultProps = {
  onSubmit: () => {},
};

export default compose(
  injectIntl,
  CSSModules(styles, { allowMultiple: true }),
)(CollapsedSendMessageItem);



// WEBPACK FOOTER //
// ./src/components/common/CollapsedSendMessageItem/index.jsx